import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';
import { baseUrlAdmin } from '../../store/apiConstants';

class BranchToSectionApprovalHierarchy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            branchIds: null,
            sectionId: null,
            boards: [],
            classes: [],
            sections: [],
            heirarchy: [],
            branchesDD: [],
            isLoading: false,
            hasBeenProcessed: false // Add this flag
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');
        
        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }
        
        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];
        
        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.shouldUpdateState(prevState)) {
            this.updateStateWithFilteredData();
        }

        // When hierarchy has no configured branches but branchData just loaded, use all branches as fallback
        const branchIds = this.state.heirarchy?.branchIds;
        if (
            prevProps.branchData?.length === 0 &&
            this.props.branchData?.length > 0 &&
            Array.isArray(branchIds) &&
            branchIds.length === 0 &&
            !this.state.hasBeenProcessed
        ) {
            const fallbackBranchIds = this.props.branchData.map((b) => b.key);
            this.setState({
                heirarchy: { branchIds: fallbackBranchIds, adminLevels: [] }
            });
        }
    }

    shouldUpdateState(prevState) {
        // Add check to prevent infinite loop when autoSelectDefaults is false
        const hasHierarchyData = this.state?.heirarchy?.branchIds?.length > 0;
        const hasRequiredProps = this.props.boards?.length > 0 && this.props.branchData?.length > 0;
        const hasNotBeenInitialized = this.state.branchIds == null && !prevState.branchIds;

        // Add a flag to track if we've already processed the data
        const hasNotBeenProcessed = !this.state.hasBeenProcessed;

        return hasHierarchyData && hasRequiredProps && hasNotBeenInitialized && hasNotBeenProcessed;
    }

    getData = () => {
        this.getUserAssignedHeirarchy();
        /*         this.props.getBranchesLatest();
                this.props.getBoardsData(true); */
    };

    getUserAssignedHeirarchy = () => {
        this.setState({ isLoading: true });
        const url = `${baseUrlAdmin}/settings-approvals/userAssignedBoards?approvalType=${this.props.approvalType}`;

        this.service
            .get(url, true)
            .then((res) => {
                if (res?.status && res?.res?.status) {
                    this.setState({
                        heirarchy: { branchIds: res?.res?.data?.data?.map((d) => d.branchId) || [], adminLevels: res?.res?.data?.adminUserAssignedLevelDetails || [] },
                        isLoading: false
                    });
                } else {
                    // No hierarchy config found — fall back to all branches from Redux so dropdowns still populate
                    const fallbackBranchIds = this.props.branchData?.map((b) => b.key) || [];
                    this.setState({
                        heirarchy: { branchIds: fallbackBranchIds, adminLevels: [] },
                        isLoading: false
                    });
                }
            })
            .catch((e) => {
                const fallbackBranchIds = this.props.branchData?.map((b) => b.key) || [];
                this.setState({
                    heirarchy: { branchIds: fallbackBranchIds, adminLevels: [] },
                    isLoading: false
                });
            });
    };

    updateStateWithFilteredData() {
        const { boards, branchData } = this.props;
        const { heirarchy } = this.state;

        const branchess = branchData.filter((item) => heirarchy?.branchIds?.includes(item.key));
        const branchdIds = branchess.map((e) => e.key);

        const filteredBoards = this.getFilteredBoards(boards, branchdIds);

        if (filteredBoards.length > 0) {
            this.processFilteredBoards(filteredBoards, branchdIds);
        } else if (branchdIds.length > 0) {
            // No boards mapped to these branches (e.g., transport-only branches).
            // Still notify parent with branch context so approval listings can load.
            this.setState(
                {
                    branchIds: branchdIds,
                    branchesDD: branchData.filter((item) => heirarchy?.branchIds?.includes(item.key)),
                    hasBeenProcessed: true
                },
                this.setDropdownsData
            );
        }
    }

    getFilteredBoards(boards, branchIds) {
        const { userInfo } = this.props;

        let filteredBoards = cloneDeep(
            boards.filter((board) => {
                return board.assignedBranches.some((branchId) => branchIds.includes(branchId));
            })
        );

        // If user is admin, return boards filtered only by selected branches
        if (userInfo?.isAdmin === true) {
            // Remove duplicate boards by boardId
            filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');
        } else {
            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }

            // Remove duplicate boards by boardId
            filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');
        }

        return filteredBoards;
    }

    processFilteredBoards(filteredBoards, branchIds) {
        this.formatBoardData(filteredBoards);

        const boardIds = filteredBoards.map((e) => e.boardId);
        const filterClasses = this.getFilteredClasses(filteredBoards, boardIds[0]);
        
        // Remove duplicate classes
        const uniqueClasses = this.removeDuplicates(filterClasses, 'classId');
        
        const filterClassIds = uniqueClasses.map((e) => e.classId);
        const filteredSections = this.getFilteredSections(uniqueClasses, filterClassIds[0], branchIds);

        this.setNewState(filteredBoards, uniqueClasses, filteredSections, boardIds, filterClassIds, branchIds);
    }

    formatBoardData(boards) {
        boards.forEach((board) => {
            // Remove duplicate classes
            board.classes = this.removeDuplicates(board.classes || [], 'classId');
            
            board?.classes?.forEach((classs) => {
                classs.className = classs.className?.includes('--') ? classs.className : `${board?.boardName} -- ${classs.className}`;
                
                // Remove duplicate sections
                classs.sections = this.removeDuplicates(classs.sections || [], 'sectionId');
                
                classs?.sections?.forEach((sec) => {
                    sec.sectionName = sec.sectionName?.includes('--') ? sec.sectionName : `${classs.className} -- ${sec.sectionName}`;
                });
            });
        });
    }

    getFilteredClasses(boards, boardId) {
        return boards
            ?.filter((board) => board.boardId === boardId)
            ?.map((e) => e.classes)
            .flat();
    }

    getFilteredSections(classes, classId, branchIds = null) {
        const filteredSections = classes
            .filter((e) => e.classId === classId)
            ?.map((e) => e.sections)
            .flat();
            
        // If branchIds is provided, filter sections by branch
        let finalSections = filteredSections;
        if (branchIds && branchIds.length > 0) {
            finalSections = filteredSections.filter(sec => branchIds.includes(sec?.branchId));
        }
        
        // Apply user role-based section filtering
        return this.getFilteredSectionsByRole(finalSections);
    }

    // Filter sections based on user role and assigned sections
    getFilteredSectionsByRole = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections || [], 'sectionId');
        }

        // For teachers, filter by assigned sections
        if (this.isTeacher()) {
            // If teacher has no assigned sections, return empty array
            if (!userInfo?.sections || userInfo.sections.length === 0) {
                return [];
            }

            const filtered = sections.filter(section =>
                userInfo.sections.includes(section.sectionId)
            );
            return this.removeDuplicates(filtered, 'sectionId');
        }

        // For non-teacher users, return all sections
        return this.removeDuplicates(sections || [], 'sectionId');
    }

    setNewState(filteredBoards, filterClasses, filteredSections, boardIds, filterClassIds, branchIds) {
        // Further filter sections to ensure they belong to the first selected branch only
        const properlyFilteredSections = filteredSections.filter(sec => {
            // Only include sections that belong to the FIRST selected branch
            const belongsToFirstBranch = sec?.branchId === branchIds[0];
            
            // Additional check: ensure this section's board is the one we're looking at
            const belongsToCurrentBoard = filteredBoards.some(board => 
                board.boardId === boardIds[0] && 
                board.assignedBranches?.includes(sec?.branchId) &&
                board.classes?.some(cls => 
                    cls.classId === filterClassIds[0] && 
                    cls.sections?.some(s => s.sectionId === sec.sectionId)
                )
            );
            
            return belongsToFirstBranch && belongsToCurrentBoard;
        });

        // Apply user role-based filtering to final sections
        const finalFilteredSections = this.getFilteredSectionsByRole(properlyFilteredSections);
        
        const sectionIds = finalFilteredSections?.map((e) => e.sectionId);
        const selectedSectionName = finalFilteredSections.length > 0 ? finalFilteredSections[0].sectionName : '';
        const selectedSectionId = sectionIds?.length > 0 ? sectionIds[0] : '';

        // Check if autoSelectDefaults prop is false (for studentPromotions)
        const shouldAutoSelect = this.props.autoSelectDefaults !== false;

        this.setState(
            {
                branches: shouldAutoSelect ? filterClasses[0]?.branches : [],
                branchIds: shouldAutoSelect ? [branchIds[0]] : [],
                boards: shouldAutoSelect ? filteredBoards : [], // Empty when autoSelect is false
                boardIds: shouldAutoSelect ? [boardIds[0]] : [],
                classes: shouldAutoSelect ? filterClasses : [], // Empty when autoSelect is false
                classIds: shouldAutoSelect ? [filterClassIds[0]] : [],
                selectedClassName: shouldAutoSelect ? filterClasses[0]?.className : '',
                selectedbranchName: shouldAutoSelect ? filterClasses[0]?.branches?.[0]?.branchName : '',
                sections: shouldAutoSelect ? finalFilteredSections : [], // Use properly filtered sections
                sectionId: shouldAutoSelect ? selectedSectionId : '',
                selectedsectionName: shouldAutoSelect ? selectedSectionName : '',
                branchesDD: this.props.branchData.filter((item) => this.state?.heirarchy?.branchIds.includes(item.key)),
                hasBeenProcessed: true
            },
            this.setDropdownsData
        );
    }

    onChangeBranch = (branchIds) => {
        const filteredBoards = this.getFilteredBoards(this.props.boards, branchIds);
        this.formatBoardData(filteredBoards);

        this.setState(
            {
                branchIds,
                boards: filteredBoards,
                classes: [],
                boardIds: '',
                classIds: '',
                branches: [],
                sections: [],
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeBoard = (boardIds) => {
        let filteredClasses = [];

        this.state.boards.forEach((board) => {
            if (boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        // Remove duplicate classes by classId
        filteredClasses = this.removeDuplicates(filteredClasses, 'classId');

        this.setState(
            {
                classes: filteredClasses,
                boardIds,
                classIds: '',
                branches: [],
                sections: [],
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeClass = (classIds) => {
        let filteredSections = [];
        
        // For each selected class ID
        classIds?.forEach(classId => {
            // Find the class in the current classes
            const selectedClass = this.state.classes?.find(cls => cls.classId === classId);
            
            if (selectedClass && selectedClass.sections) {
                // Filter sections for this specific class
                const validSections = selectedClass.sections.filter(sec => {
                    // Check if section belongs to selected branch
                    const belongsToSelectedBranch = this.state.branchIds?.includes(sec?.branchId);
                    
                    // Check if section is from the selected board
                    const isFromSelectedBoard = this.state.boardIds?.some(boardId => {
                        const board = this.state.boards.find(b => b.boardId === boardId);
                        if (!board) return false;
                        
                        // Verify this board:
                        // 1. Is assigned to the section's branch
                        // 2. Contains this specific class
                        // 3. Contains this specific section
                        const isBoardAssignedToBranch = board.assignedBranches?.includes(sec?.branchId);
                        const boardHasThisClass = board.classes?.some(cls => cls.classId === classId);
                        const boardHasThisSection = board.classes?.some(cls => 
                            cls.classId === classId && 
                            cls.sections?.some(s => s.sectionId === sec.sectionId)
                        );
                        
                        return isBoardAssignedToBranch && boardHasThisClass && boardHasThisSection;
                    });
                    
                    return belongsToSelectedBranch && isFromSelectedBoard;
                });
                
                filteredSections.push(...validSections);
            }
        });

        // Apply user role-based filtering to sections and remove duplicates
        filteredSections = this.getFilteredSectionsByRole(filteredSections);

        this.setState(
            {
                classIds,
                sections: filteredSections,
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeSection = (sectionId) => {
        const selectedSection = this.state.sections?.find((section) => section.sectionId === sectionId);
        const selectedsectionName = selectedSection?.sectionName || '';

        this.setState(
            {
                sectionId,
                selectedsectionName
            },
            this.setDropdownsData
        );
    };

    setDropdownsData = () => {
        const { boardIds, classIds, branchIds, sectionId, heirarchy } = this.state;
        this.props.setValues({
            boardIds,
            classIds,
            branchIds,
            sectionId,
            heirarchy
        });
    };

    render() {
        const { branchesDD, branchIds, boards, boardIds, classes, classIds, sections, sectionId, isLoading } = this.state;
        const { selectedValue } = this.props;
        const isDisabled = selectedValue === 2;

        return (
            <div>
                <div>
                    <div className="grid m-2">
                        <div className="col-3">
                            <ClassetMultiSelect
                                required={true}
                                label="Branch"
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder="Select Branch"
                                options={branchesDD || []}
                                value={branchIds}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetMultiSelect
                                label="Board"
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder="Select Board"
                                options={boards || []}
                                value={boardIds}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetMultiSelect
                                label="Grade"
                                // icon={<GradesIcon />}
                                placeholder="Select (Board - Grade)"
                                options={classes || []}
                                value={classIds}
                                onChange={(e) => this.onChangeClass(e.value)}
                                optionLabel="className"
                                optionValue="classId"
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetDropdown
                                label="Section"
                                // icon={<GradesIcon />}
                                placeholder="Select (Board - Grade - Section)"
                                options={sections || []}
                                value={sectionId}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                </div>
                <Toast ref={this.toast} position="bottom-right" />
                {isLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest?.data?.data?.filter((each) => each.level === 1) || [],
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo || {}
});

export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionApprovalHierarchy);
